/* eslint-disable @typescript-eslint/ban-types */
import React, { useMemo, useEffect, useState } from 'react';
import { optionsMap, GALLERY_CONSTS, isEditMode } from 'pro-gallery-lib';
import { GalleryUI } from './GalleryUI.js';
import { utils } from 'pro-gallery-lib';
import ImageItem from '../imageItem.js';
import IframeVideoPlayer from '../videos/IframeVideoPlayer.js';
const getPlayButtonComponentByItemType = (type) => {
    if (type === 'video') {
        return React.createElement(GalleryUI, { type: 'videoPlayButton', size: 60 });
    }
    else if (type === '3d') {
        return React.createElement(GalleryUI, { type: 'rotateArrow', size: 60 });
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
export default function MediaItem(props) {
    const { hasLink, options, imageDimensions, showPlayButton, MediaImplementation, enableImagePlaceholder, isVideoPlaceholder, videoPlaceholderUrl, } = props;
    const { behaviourParams_item_clickAction: clickAction, behaviourParams_item_video_playTrigger: playTrigger } = options;
    const [isMounted, setIsMounted] = useState(false);
    useEffect(() => {
        setIsMounted(true);
    }, []);
    const isMediaPlayable = useMemo(() => {
        if (utils.isSSR()) {
            return false;
        }
        if (playTrigger === GALLERY_CONSTS[optionsMap.behaviourParams.item.video.playTrigger].HOVER ||
            playTrigger === GALLERY_CONSTS[optionsMap.behaviourParams.item.video.playTrigger].AUTO) {
            return true;
        }
        else if (clickAction === GALLERY_CONSTS[optionsMap.behaviourParams.item.clickAction].NOTHING ||
            clickAction === GALLERY_CONSTS[optionsMap.behaviourParams.item.clickAction].MAGNIFY) {
            return true;
        }
        else if (clickAction === GALLERY_CONSTS[optionsMap.behaviourParams.item.clickAction].LINK && !hasLink) {
            return true;
        }
        return false;
    }, [hasLink, playTrigger, clickAction]);
    const createIframePlayer = () => (React.createElement(IframeVideoPlayer, { dimensions: imageDimensions, url: isVideoPlaceholder ? videoPlaceholderUrl : props.videoUrl }));
    const createThumbnail = (propsOverrides = {}) => enableImagePlaceholder ? (React.createElement(ImageItem, Object.assign({}, props, { imageDimensions: imageDimensions, id: props.idx, overlay: showPlayButton && !isMediaPlayable && getPlayButtonComponentByItemType(props.type), extraClasses: props.placeholderExtraClasses.join(' ') }, propsOverrides))) : (React.createElement(React.Fragment, null));
    const thumbnail = createThumbnail();
    const iframeVideoPlayer = createIframePlayer();
    const placeholder = (React.createElement(React.Fragment, null,
        thumbnail,
        iframeVideoPlayer,
        props.hover));
    if (!isMediaPlayable || props.isPrerenderMode || !isMounted) {
        return placeholder;
    }
    if (isEditMode()) {
        return (React.createElement(React.Fragment, null,
            thumbnail,
            props.hover));
    }
    return (React.createElement(React.Suspense, { fallback: placeholder },
        React.createElement(MediaImplementation, Object.assign({}, props, { thumbnail: thumbnail, placeholder: placeholder, thumbnailWithOverride: createThumbnail }))));
}
//# sourceMappingURL=mediaItem.js.map